export const DUBBOT_CRAWLER_USER_AGENT = "Mozilla/5.0 (compatible; Dubbotbot/0.2; +http://dubbot.com)";

export const HTTP_STATUS_CODES = {
  "100": "Continue",
  "101": "Switching Protocols",
  "102": "Processing",
  "103": "Early Hints",
  "200": "OK",
  "201": "Created",
  "202": "Accepted",
  "203": "Non-Authoritative Information",
  "204": "No Content",
  "205": "Reset Content",
  "206": "Partial Content",
  "207": "Multi-Status",
  "208": "Already Reported",
  "226": "IM Used",
  "300": "Multiple Choices",
  "301": "Moved Permanently",
  "302": "Found",
  "303": "See Other",
  "304": "Not Modified",
  "305": "Use Proxy",
  "307": "Temporary Redirect",
  "308": "Permanent Redirect",
  "400": "Bad Request",
  "401": "Unauthorized",
  "402": "Payment Required",
  "403": "Forbidden",
  "404": "Not Found",
  "405": "Method Not Allowed",
  "406": "Not Acceptable",
  "407": "Proxy Authentication Required",
  "408": "Request Timeout",
  "409": "Conflict",
  "410": "Gone",
  "411": "Length Required",
  "412": "Precondition Failed",
  "413": "Payload Too Large",
  "414": "URI Too Long",
  "415": "Unsupported Media Type",
  "416": "Range Not Satisfiable",
  "417": "Expectation Failed",
  "418": "I'm a Teapot",
  "421": "Misdirected Request",
  "422": "Unprocessable Entity",
  "423": "Locked",
  "424": "Failed Dependency",
  "425": "Too Early",
  "426": "Upgrade Required",
  "428": "Precondition Required",
  "429": "Too Many Requests",
  "431": "Request Header Fields Too Large",
  "440": "Login Time-out",
  "444": "No Response",
  "449": "Retry With",
  "450": "Blocked by Windows Parental Controls",
  "451": "Unavailable For Legal Reasons",
  "460": "Client closed connection prematurely",
  "461": "Login Time-out",
  "463": "Too many forwarded IP addresses",
  "464": "Incompatible protocol",
  "494": "Request header too large",
  "495": "SSL Certificate Error",
  "496": "SSL Certificate Required",
  "497": "HTTP Request Sent to HTTPS Port",
  "498": "Invalid Token",
  "499": "Token Required or Client Closed Request",
  "500": "Internal Server Error",
  "501": "Not Implemented",
  "502": "Bad Gateway",
  "503": "Service Unavailable",
  "504": "Gateway Timeout",
  "505": "HTTP Version Not Supported",
  "506": "Variant Also Negotiates",
  "507": "Insufficient Storage",
  "508": "Loop Detected",
  "509": "Bandwidth Limit Exceeded",
  "510": "Not Extended",
  "511": "Network Authentication Required"
};

export const ErrorsAttributes = `
errorMessages
errors {
  attribute
  code
  data {
    key
    value
    valueArray
  }
}
`;

export const axeRuleData = [
  {
    "rule_ID": "wcag2a",
    "type": "Requirement",
    "violation": "WCAG 2.0 Level A",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "wcag2aa",
    "type": "Requirement",
    "violation": "WCAG 2.0 Level AA",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": []
  },
  {
    "rule_ID": "wcag2aaa",
    "type": "Requirement",
    "violation": "WCAG 2.0 Level AAA",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": []
  },
  {
    "rule_ID": "wcag21a",
    "type": "Requirement",
    "violation": "WCAG 2.1 Level A",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "wcag21aa",
    "type": "Requirement",
    "violation": "WCAG 2.1 Level AA",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "wcag21aaa",
    "type": "Requirement",
    "violation": "WCAG 2.1 Level AAA",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": []
  },
  {
    "rule_ID": "wcag22aa",
    "type": "Requirement",
    "violation": "WCAG 2.2 Level AA",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": []
  },
  {
    "rule_ID": "section508",
    "type": "Requirement",
    "violation": "Section 508",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "best-practice",
    "type": "Requirement",
    "violation": "Best practices",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "custom-check",
    "type": "Requirement",
    "violation": "Policy",
    "title": [],
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "wcag111",
    "type": "WCAG Success Criterion",
    "violation": "1.1.1",
    "title": "Non-text Content",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/non-text-content.html"
    }
  },
  {
    "rule_ID": "wcag121",
    "type": "WCAG Success Criterion",
    "violation": "1.2.1",
    "title": "Audio-only and Video-only (Prerecorded)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/audio-only-and-video-only-prerecorded"
    }
  },
  {
    "rule_ID": "wcag122",
    "type": "WCAG Success Criterion",
    "violation": "1.2.2",
    "title": "Captions (Prerecorded)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/captions-prerecorded"
    }
  },
  {
    "rule_ID": "wcag123",
    "type": "WCAG Success Criterion",
    "violation": "1.2.3",
    "title": "Audio Description or Media Alternative (Prerecorded)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/audio-description-or-media-alternative-prerecorded"
    }
  },
  {
    "rule_ID": "wcag124",
    "type": "WCAG Success Criterion",
    "violation": "1.2.4",
    "title": "Captions (Live)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/captions-live"
    }
  },
  {
    "rule_ID": "wcag125",
    "type": "WCAG Success Criterion",
    "violation": "1.2.5",
    "title": "Audio Description (Prerecorded)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": "https://www.w3.org/WAI/WCAG21/Understanding/audio-description-prerecorded"
  },
  {
    "rule_ID": "wcag126",
    "type": "WCAG Success Criterion",
    "violation": "1.2.6",
    "title": "Sign Language (Prerecorded)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/sign-language-prerecorded"
    }
  },
  {
    "rule_ID": "wcag127",
    "type": "WCAG Success Criterion",
    "violation": "1.2.7",
    "title": "Extended Audio Description (Prerecorded)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/extended-audio-description-prerecorded"
    }
  },
  {
    "rule_ID": "wcag128",
    "type": "WCAG Success Criterion",
    "violation": "1.2.8",
    "title": "Media Alternative (Prerecorded)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/media-alternative-prerecorded"
    }
  },
  {
    "rule_ID": "wcag129",
    "type": "WCAG Success Criterion",
    "violation": "1.2.9",
    "title": "Audio-only (Live)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/audio-only-live"
    }
  },
  {
    "rule_ID": "wcag131",
    "type": "WCAG Success Criterion",
    "violation": "1.3.1",
    "title": "Info and Relationships",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/info-and-relationships"
    }
  },
  {
    "rule_ID": "wcag132",
    "type": "WCAG Success Criterion",
    "violation": "1.3.2",
    "title": "Meaningful Sequence",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/meaningful-sequence"
    }
  },
  {
    "rule_ID": "wcag133",
    "type": "WCAG Success Criterion",
    "violation": "1.3.3",
    "title": "Sensory Characteristics",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/sensory-characteristics"
    }
  },
  {
    "rule_ID": "wcag134",
    "type": "WCAG Success Criterion",
    "violation": "1.3.4",
    "title": "Orientation",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/orientation"
    }
  },
  {
    "rule_ID": "wcag135",
    "type": "WCAG Success Criterion",
    "violation": "1.3.5",
    "title": "Identify Input Purpose",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/identify-input-purpose"
    }
  },
  {
    "rule_ID": "wcag136",
    "type": "WCAG Success Criterion",
    "violation": "1.3.6",
    "title": "Identify Purpose",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/identify-purpose"
    }
  },
  {
    "rule_ID": "wcag141",
    "type": "WCAG Success Criterion",
    "violation": "1.4.1",
    "title": "Use of Color",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/use-of-color"
    }
  },
  {
    "rule_ID": "wcag142",
    "type": "WCAG Success Criterion",
    "violation": "1.4.2",
    "title": "Audio Control",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/audio-control"
    }
  },
  {
    "rule_ID": "wcag143",
    "type": "WCAG Success Criterion",
    "violation": "1.4.3",
    "title": "Contrast (Minimum)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum"
    }
  },
  {
    "rule_ID": "wcag144",
    "type": "WCAG Success Criterion",
    "violation": "1.4.4",
    "title": "Resize text",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/resize-text"
    }
  },
  {
    "rule_ID": "wcag145",
    "type": "WCAG Success Criterion",
    "violation": "1.4.5",
    "title": "Images of Text",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/images-of-text"
    }
  },
  {
    "rule_ID": "wcag146",
    "type": "WCAG Success Criterion",
    "violation": "1.4.6",
    "title": "Contrast (Enhanced)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced"
    }
  },
  {
    "rule_ID": "wcag147",
    "type": "WCAG Success Criterion",
    "violation": "1.4.7",
    "title": "Low or No Background Audio",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/low-or-no-background-audio"
    }
  },
  {
    "rule_ID": "wcag148",
    "type": "WCAG Success Criterion",
    "violation": "1.4.8",
    "title": "Visual Presentation",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/visual-presentation"
    }
  },
  {
    "rule_ID": "wcag149",
    "type": "WCAG Success Criterion",
    "violation": "1.4.9",
    "title": "Images of Text (No Exception)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/images-of-text-no-exception"
    }
  },
  {
    "rule_ID": "wcag1410",
    "type": "WCAG Success Criterion",
    "violation": "1.4.10",
    "title": "Reflow",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/reflow"
    }
  },
  {
    "rule_ID": "wcag1411",
    "type": "WCAG Success Criterion",
    "violation": "1.4.11",
    "title": "Non-text Contrast",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/non-text-contrast"
    }
  },
  {
    "rule_ID": "wcag1412",
    "type": "WCAG Success Criterion",
    "violation": "1.4.12",
    "title": "Text Spacing",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/text-spacing"
    }
  },
  {
    "rule_ID": "wcag1413",
    "type": "WCAG Success Criterion",
    "violation": "1.4.13",
    "title": "Content on Hover or Focus",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/content-on-hover-or-focus"
    }
  },
  {
    "rule_ID": "wcag211",
    "type": "WCAG Success Criterion",
    "violation": "2.1.1",
    "title": "Keyboard",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/keyboard"
    }
  },
  {
    "rule_ID": "wcag212",
    "type": "WCAG Success Criterion",
    "violation": "2.1.2",
    "title": "No Keyboard Trap",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/no-keyboard-trap"
    }
  },
  {
    "rule_ID": "wcag213",
    "type": "WCAG Success Criterion",
    "violation": "2.1.3",
    "title": "Keyboard (No Exception)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/keyboard-no-exception"
    }
  },
  {
    "rule_ID": "wcag214",
    "type": "WCAG Success Criterion",
    "violation": "2.1.4",
    "title": "Character Key Shortcuts",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/character-key-shortcuts"
    }
  },
  {
    "rule_ID": "wcag221",
    "type": "WCAG Success Criterion",
    "violation": "2.2.1",
    "title": "Timing Adjustable",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/timing-adjustable"
    }
  },
  {
    "rule_ID": "wcag222",
    "type": "WCAG Success Criterion",
    "violation": "2.2.2",
    "title": "Pause, Stop, Hide",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/pause-stop-hide"
    }
  },
  {
    "rule_ID": "wcag223",
    "type": "WCAG Success Criterion",
    "violation": "2.2.3",
    "title": "No Timing",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/no-timing"
    }
  },
  {
    "rule_ID": "wcag224",
    "type": "WCAG Success Criterion",
    "violation": "2.2.4",
    "title": "Interruptions",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/interruptions"
    }
  },
  {
    "rule_ID": "wcag225",
    "type": "WCAG Success Criterion",
    "violation": "2.2.5",
    "title": "Re-authenticating",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/re-authenticating"
    }
  },
  {
    "rule_ID": "wcag226",
    "type": "WCAG Success Criterion",
    "violation": "2.2.6",
    "title": "Timeouts",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/timeouts"
    }
  },
  {
    "rule_ID": "wcag231",
    "type": "WCAG Success Criterion",
    "violation": "2.3.1",
    "title": "Three Flashes or Below Threshold",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/three-flashes-or-below-threshold"
    }
  },
  {
    "rule_ID": "wcag232",
    "type": "WCAG Success Criterion",
    "violation": "2.3.2",
    "title": "Three Flashes",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/three-flashes"
    }
  },
  {
    "rule_ID": "wcag233",
    "type": "WCAG Success Criterion",
    "violation": "2.3.3",
    "title": "Animation from Interactions",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/animation-from-interactions"
    }
  },
  {
    "rule_ID": "wcag241",
    "type": "WCAG Success Criterion",
    "violation": "2.4.1",
    "title": "Bypass Blocks",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/bypass-blocks"
    }
  },
  {
    "rule_ID": "wcag242",
    "type": "WCAG Success Criterion",
    "violation": "2.4.2",
    "title": "Page Titled",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/page-titled"
    }
  },
  {
    "rule_ID": "wcag243",
    "type": "WCAG Success Criterion",
    "violation": "2.4.3",
    "title": "Focus Order",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/focus-order"
    }
  },
  {
    "rule_ID": "wcag244",
    "type": "WCAG Success Criterion",
    "violation": "2.4.4",
    "title": "Link Purpose (In Context)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/link-purpose-in-context"
    }
  },
  {
    "rule_ID": "wcag245",
    "type": "WCAG Success Criterion",
    "violation": "2.4.5",
    "title": "Multiple Ways",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/multiple-ways"
    }
  },
  {
    "rule_ID": "wcag246",
    "type": "WCAG Success Criterion",
    "violation": "2.4.6",
    "title": "Headings and Labels",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/headings-and-labels"
    }
  },
  {
    "rule_ID": "wcag247",
    "type": "WCAG Success Criterion",
    "violation": "2.4.7",
    "title": "Focus Visible",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/focus-visible"
    }
  },
  {
    "rule_ID": "wcag248",
    "type": "WCAG Success Criterion",
    "violation": "2.4.8",
    "title": "Location",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/location"
    }
  },
  {
    "rule_ID": "wcag249",
    "type": "WCAG Success Criterion",
    "violation": "2.4.9",
    "title": "Link Purpose (Link Only)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/link-purpose-link-only"
    }
  },
  {
    "rule_ID": "wcag2410",
    "type": "WCAG Success Criterion",
    "violation": "2.4.10",
    "title": "Section Headings",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/section-headings"
    }
  },
  {
    "rule_ID": "wcag251",
    "type": "WCAG Success Criterion",
    "violation": "2.5.1",
    "title": "Pointer Gestures",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/pointer-gestures"
    }
  },
  {
    "rule_ID": "wcag252",
    "type": "WCAG Success Criterion",
    "violation": "2.5.2",
    "title": "Pointer Cancellation",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/pointer-cancellation"
    }
  },
  {
    "rule_ID": "wcag253",
    "type": "WCAG Success Criterion",
    "violation": "2.5.3",
    "title": "Label in Name",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/label-in-name"
    }
  },
  {
    "rule_ID": "wcag254",
    "type": "WCAG Success Criterion",
    "violation": "2.5.4",
    "title": "Motion Actuation",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/motion-actuation"
    }
  },
  {
    "rule_ID": "wcag255",
    "type": "WCAG Success Criterion",
    "violation": "2.5.5",
    "title": "Target Size (Enhanced)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG22/Understanding/target-size-enhanced"
    }
  },
  {
    "rule_ID": "wcag258",
    "type": "WCAG Success Criterion",
    "violation": "2.5.8",
    "title": "Target Size (Minimum)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG22/Understanding/target-size-minimum.html"
    }
  },
  {
    "rule_ID": "wcag256",
    "type": "WCAG Success Criterion",
    "violation": "2.5.6",
    "title": "Concurrent Input Mechanisms",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/concurrent-input-mechanisms"
    }
  },
  {
    "rule_ID": "wcag311",
    "type": "WCAG Success Criterion",
    "violation": "3.1.1",
    "title": "Language of Page",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/language-of-page.html"
    }
  },
  {
    "rule_ID": "wcag312",
    "type": "WCAG Success Criterion",
    "violation": "3.1.2",
    "title": "Language of Parts",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/language-of-parts.html"
    }
  },
  {
    "rule_ID": "wcag313",
    "type": "WCAG Success Criterion",
    "violation": "3.1.3",
    "title": "Unusual Words",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/unusual-words.html"
    }
  },
  {
    "rule_ID": "wcag314",
    "type": "WCAG Success Criterion",
    "violation": "3.1.4",
    "title": "Abbreviations",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/abbreviations.html"
    }
  },
  {
    "rule_ID": "wcag315",
    "type": "WCAG Success Criterion",
    "violation": "3.1.5",
    "title": "Reading Level",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/reading-level.html"
    }
  },
  {
    "rule_ID": "wcag316",
    "type": "WCAG Success Criterion",
    "violation": "3.1.6",
    "title": "Pronunciation",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/pronunciation.html"
    }
  },
  {
    "rule_ID": "wcag321",
    "type": "WCAG Success Criterion",
    "violation": "3.2.1",
    "title": "On Focus",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/on-focus.html"
    }
  },
  {
    "rule_ID": "wcag322",
    "type": "WCAG Success Criterion",
    "violation": "3.2.2",
    "title": "On Input",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/on-input.html"
    }
  },
  {
    "rule_ID": "wcag323",
    "type": "WCAG Success Criterion",
    "violation": "3.2.3",
    "title": "Consistent Navigation",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/consistent-navigation.html"
    }
  },
  {
    "rule_ID": "wcag324",
    "type": "WCAG Success Criterion",
    "violation": "3.2.4",
    "title": "Consistent Identification",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/consistent-identification.html"
    }
  },
  {
    "rule_ID": "wcag325",
    "type": "WCAG Success Criterion",
    "violation": "3.2.5",
    "title": "Change on Request",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/change-on-request.html"
    }
  },
  {
    "rule_ID": "wcag331",
    "type": "WCAG Success Criterion",
    "violation": "3.3.1",
    "title": "Error Identification",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/error-identification.html"
    }
  },
  {
    "rule_ID": "wcag332",
    "type": "WCAG Success Criterion",
    "violation": "3.3.2",
    "title": "Labels or Instructions",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/labels-or-instructions.html"
    }
  },
  {
    "rule_ID": "wcag333",
    "type": "WCAG Success Criterion",
    "violation": "3.3.3",
    "title": "Error Suggestion",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/error-suggestion.html"
    }
  },
  {
    "rule_ID": "wcag334",
    "type": "WCAG Success Criterion",
    "violation": "3.3.4",
    "title": "Error Prevention (Legal, Financial, Data)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/error-prevention-legal-financial-data.html"
    }
  },
  {
    "rule_ID": "wcag335",
    "type": "WCAG Success Criterion",
    "violation": "3.3.5",
    "title": "Help",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/help.html"
    }
  },
  {
    "rule_ID": "wcag336",
    "type": "WCAG Success Criterion",
    "violation": "3.3.6",
    "title": "Error Prevention (All)",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/error-prevention-all.html"
    }
  },
  {
    "rule_ID": "wcag411",
    "type": "WCAG Success Criterion",
    "violation": "4.1.1",
    "title": "Parsing",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/parsing.html"
    }
  },
  {
    "rule_ID": "wcag412",
    "type": "WCAG Success Criterion",
    "violation": "4.1.2",
    "title": "Name, Role, Value",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/name-role-value.html"
    }
  },
  {
    "rule_ID": "wcag413",
    "type": "WCAG Success Criterion",
    "violation": "4.1.3",
    "title": "Status Messages",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": "W3C Documentation",
      "link": "https://www.w3.org/WAI/WCAG21/Understanding/status-messages.html"
    }
  },
  {
    "rule_ID": "section508.22.a",
    "type": "Section 508 Guideline",
    "violation": "1194.22 (a)",
    "title": "Text equivalent for non-text elements",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "section508.22.b",
    "type": "Section 508 Guideline",
    "violation": "1194.22 (b)",
    "title": "Multimedia presentation alternatives synchronization",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "section508.22.f",
    "type": "Section 508 Guideline",
    "violation": "1194.22 (f)",
    "title": "Client-side image maps instead of server-side",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "section508.22.g",
    "type": "Section 508 Guideline",
    "violation": "1194.22 (g)",
    "title": "Row and column headers for data tables",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "section508.22.i",
    "type": "Section 508 Guideline",
    "violation": "1194.22 (i)",
    "title": "Frame titles for identification and navigation",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "section508.22.j",
    "type": "Section 508 Guideline",
    "violation": "1194.22 (j)",
    "title": "Screen flicker frequency",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "section508.22.n",
    "type": "Section 508 Guideline",
    "violation": "1194.22 (n)",
    "title": "Information required to complete electronic forms online",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  },
  {
    "rule_ID": "section508.22.o",
    "type": "Section 508 Guideline",
    "violation": "1194.22 (o)",
    "title": "Repetitive navigation link skip method",
    "link_int": {
      "label": [],
      "link": []
    },
    "link_ext": {
      "label": [],
      "link": []
    }
  }
];
